/**
 * Epilekton cart drawer extensions
 * - Syncs data-state attribute with Dawn's .active class
 * - Preserves cart-drawer-items scroll position on re-render
 * - Handles upsell add-to-cart
 */

(function () {
  'use strict';

  // Sync data-state on the cart-drawer element when Dawn toggles .active.
  // Also flips data-just-added off whenever the drawer closes, so the next
  // manual open (cart-icon click) shows the default "Your Cart" title.
  function initDataStateSync() {
    const drawer = document.querySelector('cart-drawer');
    if (!drawer) return;

    const update = () => {
      const isOpen = drawer.classList.contains('active');
      drawer.setAttribute('data-state', isOpen ? 'open' : 'closed');
      if (!isOpen) drawer.removeAttribute('data-just-added');
    };

    const observer = new MutationObserver(update);
    observer.observe(drawer, { attributes: true, attributeFilter: ['class'] });
    update();
  }

  // Mark the drawer as "just added" whenever renderContents fires.
  // Dawn calls renderContents() only after a successful add-to-cart, never on
  // a plain icon-click open, so this cleanly distinguishes the two paths.
  function initJustAddedFlag() {
    const drawer = document.querySelector('cart-drawer');
    if (!drawer || typeof drawer.renderContents !== 'function') return;
    const original = drawer.renderContents.bind(drawer);
    drawer.renderContents = function (parsedState) {
      drawer.setAttribute('data-just-added', 'true');
      return original(parsedState);
    };
  }

  // Preserve scroll position in cart-drawer-items on section re-render
  function initScrollPreservation() {
    const itemsContainer = document.getElementById('CartDrawer-CartItems');
    if (!itemsContainer) return;

    const scrollable = document.querySelector('cart-drawer-items');
    if (!scrollable) return;

    let savedScrollTop = 0;

    const observer = new MutationObserver((mutations) => {
      const hasChildListChange = mutations.some((m) => m.type === 'childList');
      if (!hasChildListChange) return;
      requestAnimationFrame(() => {
        scrollable.scrollTop = savedScrollTop;
      });
    });

    // Save scroll before any DOM mutation
    scrollable.addEventListener('scroll', () => {
      savedScrollTop = scrollable.scrollTop;
    }, { passive: true });

    observer.observe(itemsContainer, { childList: true, subtree: true });
  }

  // Upsell add-to-cart
  async function handleUpsellAdd(btn) {
    const variantId = btn.dataset.variantId;
    if (!variantId) return;

    btn.disabled = true;
    const originalText = btn.textContent;
    btn.textContent = '...';

    try {
      const addRes = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: parseInt(variantId, 10), quantity: 1 }),
      });

      if (!addRes.ok) throw new Error('add failed');

      const sectionsRes = await fetch(
        `${window.location.pathname}?sections=cart-drawer,cart-icon-bubble`
      );
      const sections = await sectionsRes.json();

      const cartDrawer = document.querySelector('cart-drawer');
      if (cartDrawer && typeof cartDrawer.renderContents === 'function') {
        cartDrawer.renderContents({ id: variantId, sections });
      }
    } catch (err) {
      console.error('[epi-cart] upsell add failed', err);
      btn.disabled = false;
      btn.textContent = originalText;
    }
  }

  function bindUpsellButtons() {
    document.addEventListener('click', (e) => {
      const btn = e.target.closest('[data-upsell-add]');
      if (btn) handleUpsellAdd(btn);
    });
  }

  function init() {
    initDataStateSync();
    initJustAddedFlag();
    initScrollPreservation();
    bindUpsellButtons();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
